import { useSetting } from '@/store/modules/setting';
import { useUserSotre } from '@/store/modules/user';
import { businessObj } from '@/hooks/constant';

import { CartType } from '../types/cart';
import { getCartList, post2Cart, post2CartBatch, post2CartDataCatch } from '@/api';
import { AddToCardQuery, AddToCardBatchQuery } from '@/api/cart/create2cart/type';
import { ShoppingCartDto, ShoppingCartVo } from '@/api/cart/get-cart/type';

export const useCart = defineStore(
  'cart',
  () => {
    const state = reactive<CartType>({
      cartItemArr: undefined,
      total: 0,
      touristId: '',
      forterToken: '',
      cartItemNum: 0,
      cartLoading: false,
      totalLoading: false
    });
    const getCartListAll = () => {
      const { state: stateSetting } = useSetting();
      const data: any = {
        currency: stateSetting.configuration.defaultCurrency
      };
      if (state.touristId) {
        data.touristId = state.touristId;
      }
      state.cartLoading = true;
      getCartList(data)
        .then(res => {
          // state.cartItemArr = res.data.items || [];
          const cartItemEntries: ShoppingCartVo[] =
            (res.data.storeItems &&
              Object.entries(res.data.storeItems).map(item => {
                // if (putObj?.storeName.toLocaleLowerCase() === item[0].toLocaleLowerCase()) {
                //   return {
                //     storeName: item[0] as string,
                //     storeAvatar: item[1][0].storeAvatar as string,
                //     productArr: (item[1] as ShoppingCartDto[]).map((self, j) => {
                //       return { ...self, showStepper: putObj.index === j ? true : false };
                //     })
                //   };
                // } else {
                //   return {
                //     storeName: item[0] as string,
                //     storeAvatar: item[1][0].storeAvatar as string,
                //     productArr: (item[1] as ShoppingCartDto[]).map(self => ({ ...self, showStepper: false }))
                //   };
                // }
                return {
                  storeName: item[0] as string,
                  storeAvatar: item[1][0].storeAvatar as string,
                  sellerUrl: `/seller/${item[1][0].sellerId}`,
                  productArr: (item[1] as ShoppingCartDto[]).map(self => ({
                    ...self,
                    showStepper: !businessObj.fifa.all.includes(self.businessId || '') && self.validFlag === 1
                  }))
                };
              })) ||
            [];
          state.cartItemArr = cartItemEntries;
          state.total = res.data.subTotal || 0;
          state.cartItemNum = res.data?.items?.length || 0;
        })
        .finally(() => {
          state.cartLoading = false;
        });
    };
    const getCartSubTotal = () => {
      const { state: stateSetting } = useSetting();
      const data: any = {
        currency: stateSetting.configuration.defaultCurrency
      };
      if (state.touristId) {
        data.touristId = state.touristId;
      }
      state.totalLoading = true;
      getCartList(data)
        .then(res => {
          state.total = res.data.subTotal || 0;
        })
        .finally(() => {
          state.totalLoading = false;
        });
    };
    const addToCart = (obj: { productId: string; businessId: string }, callback?: any) => {
      if (obj.productId && obj.businessId) {
        const data: AddToCardQuery = {
          productId: obj.productId,
          businessId: obj.businessId,
          quantity: 1
        };
        if (state.touristId) {
          data.touristId = state.touristId;
        }
        post2Cart(data).then(res => {
          const { state: stateUser } = useUserSotre();
          if (res.data?.touristId) {
            state.touristId = res.data.touristId;
          }
          if (res.code === 200) {
            state.cartItemNum++;
            ElMessage.success('success!');
            if (callback) {
              callback();
            }
            state.cartLoading = false;
          }
          if (res.code === 200 && !!stateUser?.memberInfo?.uid) {
            post2CartDataCatch({ url: location.href, buyerId: String(stateUser.memberInfo!.uid) });
          }
        });
      } else {
        ElMessage.error('failed');
      }
    };
    const addToCartBatch = (obj: { productIdList: number[]; businessId: string }, callback?: any) => {
      if (obj.productIdList.length && obj.businessId) {
        const data: AddToCardBatchQuery = {
          productIdList: obj.productIdList,
          businessId: obj.businessId,
          quantity: 1
        };
        if (state.touristId) {
          data.touristId = state.touristId;
        }
        post2CartBatch(data).then(res => {
          const { state: stateUser } = useUserSotre();
          if (res.code === 200) {
            ElMessage.success('success!');
            callback();
          }
          if (res.code === 200 && res.data?.touristId) {
            state.touristId = res.data.touristId;
          }
          if (res.code === 200 && !!stateUser?.memberInfo?.uid) {
            post2CartDataCatch({ url: location.href, buyerId: String(stateUser.memberInfo!.uid) });
          }
        });
      } else {
        ElMessage.error('failed');
      }
    };
    return { state, getCartListAll, addToCart, addToCartBatch, getCartSubTotal };
  },
  {
    persist: {
      storage: localStorage || undefined,
      omit: ['forterToken']
    }
  }
);
